class SearchInput extends HTMLElement {
    constructor() {
        super();
        this.element = this;

        this.input = this.element.querySelector("input");
        this.section = document.querySelector(`#${this.element.dataset.sectionId}`);
        this.itemToSearch = this.element.dataset.itemToSearch;
        this.itemsToSearch = this.section.querySelectorAll(`.${this.itemToSearch}`);
        this.itemsCounter = this.element.querySelector("#storesCounter");
        this.noItemsFound = this.element.querySelector("#noStoresFound");

        this.currentPredictiveSearchItems = [];

        this.init();
    }

    search(query) {
        this.itemsToSearch.forEach(item => {
            const city = item.dataset.city.toLowerCase().trim();
            const postalCode = item.dataset.postalCode.toLowerCase().trim();

            if (city.includes(query) || postalCode.includes(query)) {
                item.style.display = '';
                if (!this.currentPredictiveSearchItems.includes(item)) {
                    this.currentPredictiveSearchItems.push(item);
                }
                this.itemsCounter.innerHTML = this.currentPredictiveSearchItems.length;
                this.noItemsFound.style.display = "none";
            } else {
                item.style.display = 'none';
                this.currentPredictiveSearchItems = this.currentPredictiveSearchItems.filter(element => element !== item);
                this.itemsCounter.innerHTML = this.currentPredictiveSearchItems.length;
                if (this.currentPredictiveSearchItems.length === 0) this.noItemsFound.style.display = "block";
            }
        });
    }

    resetListVisibility() {
        this.itemsToSearch.forEach(item => {
            item.style.display = '';
            this.itemsCounter.innerHTML = this.itemsToSearch.length;
            this.noItemsFound.style.display = "none";
        });
    }

    init() {
        this.input.addEventListener('input', () => {
            const query = this.input.value.toLowerCase().trim();
            if (query.length >= 1) {
                this.itemsCounter.innerHTML = "";
                this.search(query);
            } else {
                this.resetListVisibility();
            }
        });
    }
}

customElements.define('search-input', SearchInput);